import React from 'react';

const Spinner = () => {
    return (
        <div className='flex h-screen justify-center items-center'>
            <button className="btn loading font-[1000px]">loading</button>
        </div>
    );
};

export default Spinner;